import React from 'react';
import styled from 'styled-components';
import { ItemProperty } from './CommonStyles';
import withTranslations from '../../../hocs/withTranslations';
import { ITranslations } from '../../../interfaces/ITranslationFields';
import { observer } from 'mobx-react';

interface ICartItemReward {
  rewardPoints: string;
  translations?: ITranslations;
}

const CartItemRewardWrapper = styled(ItemProperty)`
  margin-bottom: 4px;
  display: flex;
  justify-content: space-between;
`;

const RewardPointsWrapper = styled.span`
  font-size: 14px;
  font-weight: bold;
  color: black;
`;

@observer
class CartItemReward extends React.Component<ICartItemReward> {
  public render(): JSX.Element {
    const {
      props: {
        translations,
        rewardPoints,
      },
    } = this;
    const {
      cartItemRewardLabel,
      points,
    } = translations;

    return (
    <CartItemRewardWrapper className='cart-item-child cart-item-reward'>
      <span>{cartItemRewardLabel}</span>
      <RewardPointsWrapper>
        {`${rewardPoints} ${points}`}
      </RewardPointsWrapper>
    </CartItemRewardWrapper>
    );
  }
}

export default withTranslations(CartItemReward);